module.exports = __webpack_public_path__ + "static/media/come-around-sundown.ab573886.jpg";